var cubesheetData = JSON.stringify([
  {
    "_id": "1",
    "CubeName": "Living Room",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "1",
        "room": "Living Room"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Living Room"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Living Room"
      }
    ]
  },
  {
    "_id": "2",
    "CubeName": "Dining Room",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Dining Room"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "1",
        "room": "Dining Room"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Dining Room"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Dining Room"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "1",
        "room": "Dining Room"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "1",
        "room": "Dining Room"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Dining Room"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Dining Room"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Dining Room"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Dining Room"
      }
    ]
  },
  {
    "_id": "3",
    "CubeName": "Master Bedroom",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "1",
        "room": "Master Bedroom"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Master Bedroom"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Master Bedroom"
      }
    ]
  },
  {
    "_id": "4",
    "CubeName": "Nursery",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Nursery"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Nursery"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "1",
        "room": "Nursery"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Nursery"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Nursery"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Nursery"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "1",
        "room": "Nursery"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Nursery"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Nursery"
      }
    ]
  },
  {
    "_id": "5",
    "CubeName": "Appliances",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Appliances"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Appliances"
      }
    ]
  },
  {
    "_id": "6",
    "CubeName": "Kitchen",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "1",
        "room": "Kitchen"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Kitchen"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Kitchen"
      }
    ]
  },
  {
    "_id": "7",
    "CubeName": "Porch And Outdoor",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Porch And Outdoor"
      }
    ]
  },
  {
    "_id": "8",
    "CubeName": "Other Type",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Other Type"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Other Type"
      }
    ]
  },
  {
    "_id": "9",
    "CubeName": "Office",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "1",
        "room": "Office"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "1",
        "room": "Office"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Office"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Office"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "1",
        "room": "Office"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Office"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Office"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Office"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "1",
        "room": "Office"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Office"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Office"
      }
    ]
  },
  {
    "_id": "10",
    "CubeName": "Entry way",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "1",
        "room": "Entry way"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Entry way"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Entry way"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Entry way"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Entry way"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Entry way"
      }
    ]
  },
  {
    "_id": "11",
    "CubeName": "Family room",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "1",
        "room": "Family room"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Family room"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Family room"
      }
    ]
  },
  {
    "_id": "12",
    "CubeName": "Garage",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "1",
        "room": "Garage"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Garage"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Garage"
      }
    ]
  },
  {
    "_id": "13",
    "CubeName": "Hallway",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Hallway"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Hallway"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Hallway"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Hallway"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Hallway"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Hallway"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Hallway"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Hallway"
      }
    ]
  },
  {
    "_id": "14",
    "CubeName": "Bathroom",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "1",
        "room": "Bathroom"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Bathroom"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "1",
        "room": "Bathroom"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Bathroom"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bathroom"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Bathroom"
      }
    ]
  },
  {
    "_id": "15",
    "CubeName": "Laundry room",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Laundry room"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "1",
        "room": "Laundry room"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "1",
        "room": "Laundry room"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "1",
        "room": "Laundry room"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "1",
        "room": "Laundry room"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Laundry room"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Laundry room"
      }
    ]
  },
  {
    "_id": "16",
    "CubeName": "Bed Room1",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "1",
        "room": "Bed Room1"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room1"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Bed Room1"
      }
    ]
  },
  {
    "_id": "17",
    "CubeName": "Bed Room2",
    "CubeSheetItemTypeDetails": [
      {
        "itemId": "462",
        "item": "Armoire",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "55",
        "item": "Bed, King",
        "cubes": "70",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "54",
        "item": "Bed, Queen",
        "cubes": "65",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "53",
        "item": "Bed, Std/Dbl.",
        "cubes": "60",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "306",
        "item": "Chest of Drawers",
        "cubes": "25",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "253",
        "item": "Dresser",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "67",
        "item": "Dresser, Double",
        "cubes": "50",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "66",
        "item": "Dresser, Single",
        "cubes": "30",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "68",
        "item": "Dresser, Triple",
        "cubes": "50",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "208",
        "item": "Lamp",
        "cubes": "5",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "191",
        "item": "Mirror",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "383",
        "item": "Table, Bedside",
        "cubes": "10",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "233",
        "item": "TV",
        "cubes": "12",
        "defaultItem": "1",
        "room": "Bed Room2"
      },
      {
        "itemId": "194",
        "item": "Adjuster",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "87",
        "item": "AirCond/Wind. Lg.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "86",
        "item": "AirCond/Wind. Sm.",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "432",
        "item": "Antique Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "481",
        "item": "Arcade Game",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "501",
        "item": "Arm chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "303",
        "item": "ARMOIR-LG",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "304",
        "item": "ARMOIR-SM",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "371",
        "item": "Art",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "389",
        "item": "Artwork",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "140",
        "item": "Baby Carriage",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "453",
        "item": "Baby gate",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "236",
        "item": "Baker's Rack",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "375",
        "item": "Bar Stool",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "1",
        "item": "Bar, Portable",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "396",
        "item": "Barbecue",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "141",
        "item": "Barbells In lbs.",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "142",
        "item": "Basket (Clothes)",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "324",
        "item": "Bath Bird",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "76",
        "item": "Bathinette",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "112",
        "item": "BBQ Grill, Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "111",
        "item": "BBQ Grill, Small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "495",
        "item": "Bean Bag",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "382",
        "item": "Bed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "514",
        "item": "Bed frame",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "463",
        "item": "Bed headboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "441",
        "item": "Bed Hospital",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "197",
        "item": "Bed rails",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "51",
        "item": "Bed Rollaway",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "447",
        "item": "Bed trundle",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "56",
        "item": "Bed, Bunk (Set 2)",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "52",
        "item": "Bed, Single/Hollywood",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "77",
        "item": "Bed, Youth",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "440",
        "item": "Bedding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "206",
        "item": "Bench",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "2",
        "item": "Bench, Frsd/Piano",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "43",
        "item": "Bench, Harvest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "143",
        "item": "Bicycle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "399",
        "item": "Bike Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "479",
        "item": "Bikes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "330",
        "item": "Bird cage and Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "103",
        "item": "Bkft. Suite, Chairs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "3",
        "item": "Bookcase",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "477",
        "item": "Bookshelf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "4",
        "item": "Bookshelves, Sect.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "320",
        "item": "Bookshelves, Sectional",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "145",
        "item": "Bowling Ball/Bag",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "104",
        "item": "Breakfast Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "44",
        "item": "Buffet (Base)",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "216",
        "item": "Buffet marble top",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "426",
        "item": "Buffet, top",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "237",
        "item": "Bunk Bed",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "380",
        "item": "Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "482",
        "item": "Cabinet small",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "307",
        "item": "Cabinet, China",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "46",
        "item": "Cabinet, Corner",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "5",
        "item": "Cabinet, Curio",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "415",
        "item": "Candlestick",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "241",
        "item": "Canopy",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "492",
        "item": "Car seat",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "146",
        "item": "Card Table",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "471",
        "item": "Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "420",
        "item": "Cat tree",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "442",
        "item": "Ceramic table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "235",
        "item": "Chair",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "509",
        "item": "Chair dining",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "439",
        "item": "Chair Folding",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "460",
        "item": "Chair patio",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "313",
        "item": "Chair Porch",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "7",
        "item": "Chair, Arm",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "57",
        "item": "Chair, Boudoir",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "78",
        "item": "Chair, Childs",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "424",
        "item": "Chair, Desk",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "308",
        "item": "Chair, Dining",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "79",
        "item": "Chair, High",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "9",
        "item": "Chair, Occasional",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "10",
        "item": "Chair, Overstuffed",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "485",
        "item": "Chair, patio",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "391",
        "item": "Chair, Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "8",
        "item": "Chair, Rocker",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "58",
        "item": "Chair, Str/Rocker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "6",
        "item": "Chair, Straight",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "270",
        "item": "Chair-Ratan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "472",
        "item": "Chairs",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "325",
        "item": "Chairs Lawn",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "113",
        "item": "Chairs, Aluminum",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "114",
        "item": "Chairs, Metal",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "115",
        "item": "Chairs, Wood",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "59",
        "item": "Chaise Lounge",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "404",
        "item": "Changing table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "80",
        "item": "Chest",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "62",
        "item": "Chest, Armoire",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "60",
        "item": "Chest, Bachelor",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "61",
        "item": "Chest, Cedar",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "81",
        "item": "Chest, Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "300",
        "item": "Child Toy ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "202",
        "item": "China Cabinet",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "196",
        "item": "China Figurines",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "425",
        "item": "Christmas Tree",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "429",
        "item": "Clock Small",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "11",
        "item": "Clock, Grandfather",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "327",
        "item": "Clothes Dryer Rack",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "147",
        "item": "Clothes Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "326",
        "item": "Clothes Line",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "387",
        "item": "Coat Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "244",
        "item": "Compressor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "418",
        "item": "Computer",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "506",
        "item": "Conference table",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "193",
        "item": "Cooler/ Ice Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "248",
        "item": "Cork board ",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "411",
        "item": "Corner cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "148",
        "item": "Cot, Folding",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "410",
        "item": "Couch",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "229",
        "item": "Credenza",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "82",
        "item": "Crib",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "466",
        "item": "Cube shelves",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "227",
        "item": "Cubicle Wall",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "302",
        "item": "Curio Cabinet ",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "12",
        "item": "Day Bed",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "483",
        "item": "Decorations",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "88",
        "item": "Dehumidifier",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "263",
        "item": "Desk",
        "cubes": "75",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "210",
        "item": "Desk Chair",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "230",
        "item": "Desk With Return",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "423",
        "item": "Desk, computer",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "149",
        "item": "Desk, Office",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "13",
        "item": "Desk, Secretary",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "63",
        "item": "Desk, SM/Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "314",
        "item": "Desk, Small or Winthrop",
        "cubes": "22",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "272",
        "item": "Desk-Pressboard/Particle Board",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "47",
        "item": "Dining Chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "215",
        "item": "Dining Room Table Marble",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "386",
        "item": "Dining table",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "89",
        "item": "Dishwasher",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "256",
        "item": "Display Case",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "288",
        "item": "Doghouse",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "400",
        "item": "Dolly",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "403",
        "item": "Dorm Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "452",
        "item": "Dresser Mirror",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "217",
        "item": "Dresser Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "65",
        "item": "Dresser, Vanity",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "64",
        "item": "Dresser/Vanity Bch",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "268",
        "item": "Drill Press",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "284",
        "item": "Drum Kit",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "283",
        "item": "Drum kit, Electric",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "450",
        "item": "Drums in Case",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "102",
        "item": "Dryer",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "417",
        "item": "Duffle Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "428",
        "item": "Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "257",
        "item": "Engine Stand",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "279",
        "item": "Ent. Center",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "192",
        "item": "Entertainment Center",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "200",
        "item": "Excercise Bike",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "221",
        "item": "Excercise Pads",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "69",
        "item": "Exercise Bike",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "290",
        "item": "Exercise Equip., Ex. Large",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "289",
        "item": "Exercise Equip., Large",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "276",
        "item": "Extra Large Wall Unit ",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "150",
        "item": "Fan",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "151",
        "item": "Fern/Plant Stands",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "489",
        "item": "File 2dwr",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "271",
        "item": "File Cabinet-Latteral 2 Drawer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "491",
        "item": "File, 4drawer",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "153",
        "item": "Filing Cab. 2 door",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "154",
        "item": "Filing Cab. 4 door",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "152",
        "item": "Filing Cab. Crdbd.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "408",
        "item": "Fire Pit",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "14",
        "item": "Fireplace Equip.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "430",
        "item": "Fireplace marble",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "498",
        "item": "Fish tank",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "488",
        "item": "Fishing rods",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "296",
        "item": "Flat Screen TV ",
        "cubes": "11",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "234",
        "item": "Folding Chair",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "431",
        "item": "Footboard",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "155",
        "item": "Footlockers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "15",
        "item": "Footstool",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "393",
        "item": "Fountain",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "252",
        "item": "Freezer",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "90",
        "item": "Freezer 10 or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "91",
        "item": "Freezer 11 to 15",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "92",
        "item": "Freezer 16 or Over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "198",
        "item": "Fridge",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "457",
        "item": "Futon",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "156",
        "item": "Game Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "331",
        "item": "Garbage Cans",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "116",
        "item": "Gard. Hose &amp; Tools",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "487",
        "item": "Garden hose",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "478",
        "item": "Garden tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "225",
        "item": "Gazelle",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "287",
        "item": "Generator",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "190",
        "item": "Glass",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "183",
        "item": "Glass Door",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "189",
        "item": "Glass Frame",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "184",
        "item": "Glass Panels",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "117",
        "item": "Glider or Settee",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "157",
        "item": "Golf Bag",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "465",
        "item": "Grandfather clock",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "409",
        "item": "Greenegg",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "384",
        "item": "Grill",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "490",
        "item": "Guitar",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "280",
        "item": "Gun Safe",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "17",
        "item": "Hall Tree Large",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "16",
        "item": "Hall Tree Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "275",
        "item": "Hamper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "291",
        "item": "Harley Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "278",
        "item": "Headboard",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "158",
        "item": "Heater, Gas/Elec.",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "297",
        "item": "High Chair",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "238",
        "item": "Hope Chest",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "45",
        "item": "Hutch (Top)",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "231",
        "item": "Ironing Board",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "323",
        "item": "Ironor or Mangle",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "211",
        "item": "Jewelry Box, Large",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "212",
        "item": "Jewelry Box, Small",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "201",
        "item": "Juke Box",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "204",
        "item": "Keyboard",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "205",
        "item": "Keyboard Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "497",
        "item": "Kid car",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "493",
        "item": "Kid trailer",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "496",
        "item": "Kids chair",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "187",
        "item": "King Size Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "105",
        "item": "Kitchen Cabinet",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "435",
        "item": "Kyaks",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "118",
        "item": "Ladder, 6 Step",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "119",
        "item": "Ladder, 8 Metal",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "120",
        "item": "Ladder, Extension",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "309",
        "item": "Ladder, Step",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "70",
        "item": "Lamp, Floor",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "18",
        "item": "Lamp, Pole",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "243",
        "item": "Large Stand Green Egg Grill",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "254",
        "item": "Large Toy",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "209",
        "item": "Large Vase",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "510",
        "item": "Lateral File",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "124",
        "item": "Lawn Edger",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "121",
        "item": "Lawn Mower, Hand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "122",
        "item": "Lawn Mower, Power",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "123",
        "item": "Lawn Mower, Riding (HP)",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "372",
        "item": "Lawnmower",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "444",
        "item": "Leaf blower",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "125",
        "item": "Leaf Sweeper",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "264",
        "item": "Lift Recliner Chair",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "469",
        "item": "Locker",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "232",
        "item": "Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "19",
        "item": "Magazine Rack",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "282",
        "item": "Marble top, small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "451",
        "item": "Mattress",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "379",
        "item": "Media Cabinet",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "274",
        "item": "Metal Magazine Rack",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "332",
        "item": "Metal Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "239",
        "item": "Metal Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "470",
        "item": "Microwave",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "456",
        "item": "Microwave Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "106",
        "item": "Microwave Oven",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "398",
        "item": "Mini Fridge",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "160",
        "item": "Monitor",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "292",
        "item": "Motorcycle",
        "cubes": "150",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "20",
        "item": "Music Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "502",
        "item": "Night Stand",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "71",
        "item": "Night Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "507",
        "item": "Office chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "228",
        "item": "Office Crates",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "378",
        "item": "Ottoman",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "127",
        "item": "Outdoor Child Gym",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "126",
        "item": "Outdoor Child Slide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "128",
        "item": "Outdoor Dry. Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "129",
        "item": "Outdoor Swings",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "388",
        "item": "Painting",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "265",
        "item": "Painting Easel",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "262",
        "item": "Patio Storage",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "159",
        "item": "Personal Computer",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "223",
        "item": "Pet Bed",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "222",
        "item": "Pet Crate ",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "261",
        "item": "Phonograph Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "293",
        "item": "Piano",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "21",
        "item": "Piano, Baby Grand",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "22",
        "item": "Piano, Grand",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "23",
        "item": "Piano, Spinet/Console",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "131",
        "item": "Picnic Bench",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "130",
        "item": "Picnic Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "377",
        "item": "Pictures",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "162",
        "item": "Ping Pong Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "394",
        "item": "Plant",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "467",
        "item": "Plant stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "445",
        "item": "Plastic Drawers",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "407",
        "item": "Plastic shelf",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "448",
        "item": "Plastic Totes",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "494",
        "item": "Play mat",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "295",
        "item": "Play Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "84",
        "item": "Playpen",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "163",
        "item": "Pool Table Comp.",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "164",
        "item": "Pool Table Slate",
        "cubes": "100",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "505",
        "item": "Portrait",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "385",
        "item": "Pot",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "500",
        "item": "Pottery",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "511",
        "item": "Pottery Kiln",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "259",
        "item": "Power Amp",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "165",
        "item": "Power Tool Hand Ea.",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "166",
        "item": "Power Tool Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "333",
        "item": "Power Tools",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "245",
        "item": "Power Washer",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "258",
        "item": "Pressure Washer",
        "cubes": "14",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "161",
        "item": "Printer",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "421",
        "item": "Pub Table",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "503",
        "item": "Queen bed",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "464",
        "item": "Rack",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "24",
        "item": "Radio, Table",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "93",
        "item": "Range 20\" Wide",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "94",
        "item": "Range 30\" Wide",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "95",
        "item": "Range 36\" Wide",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "25",
        "item": "Rec. Player, Port.",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "419",
        "item": "Recliner",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "203",
        "item": "Record Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "98",
        "item": "Ref. 11 cu. ft./over",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "96",
        "item": "Ref. 6 cu. ft. or less",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "97",
        "item": "Ref. 7 to 10 cu. ft.",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "321",
        "item": "Roaster",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "328",
        "item": "Rocker, Swing",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "475",
        "item": "Rocking Chair",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "132",
        "item": "Roller, Lawn",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "499",
        "item": "Room divider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "218",
        "item": "Rubbermaid container",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "376",
        "item": "Rug",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "133",
        "item": "Rug, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "72",
        "item": "Rug, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "329",
        "item": "Rug, Small",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "85",
        "item": "Rug, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "50",
        "item": "Rugs, Large or Pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "315",
        "item": "Rugs, Large Roll or pad",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "319",
        "item": "Rugs, Small or Pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "316",
        "item": "Rugs, Small Roll or pad",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "454",
        "item": "Saddle",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "413",
        "item": "Safe",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "134",
        "item": "Sand box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "401",
        "item": "Saw, Table",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "269",
        "item": "Saw-Compound Mider",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "267",
        "item": "Screen ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "468",
        "item": "Secretary",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "48",
        "item": "Server",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "240",
        "item": "Server Rack",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "107",
        "item": "Serving Cart",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "168",
        "item": "Sewing Mach., Console",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "167",
        "item": "Sewing Mach., Port",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "169",
        "item": "Sewing Mach., w/Cabinet",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "260",
        "item": "Sewing Table",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "508",
        "item": "Shelves",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "373",
        "item": "Shelving",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "219",
        "item": "Shoe Racks",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "512",
        "item": "Shop Vac",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "414",
        "item": "Shredder",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "170",
        "item": "Sled",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "255",
        "item": "Sleigh bed",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "249",
        "item": "Small Cork Board",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "247",
        "item": "Small Desk",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "504",
        "item": "Small pool table",
        "cubes": "70",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "461",
        "item": "Smoker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "438",
        "item": "Snowblower",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "405",
        "item": "Sofa",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "446",
        "item": "Sofa 6 piece",
        "cubes": "80",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "474",
        "item": "Sofa ratan",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "251",
        "item": "Sofa Section",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "298",
        "item": "Sofa Table",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "311",
        "item": "Sofa, 2 Cushions",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "29",
        "item": "Sofa, 3 Cushion",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "30",
        "item": "Sofa, Hide, 4 Cush.",
        "cubes": "60",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "28",
        "item": "Sofa, Loveseat",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "26",
        "item": "Sofa, Rattan/Wicker",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "27",
        "item": "Sofa, Sec. Per Sec.",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "433",
        "item": "Sofaback Table",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "250",
        "item": "Speaker",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "427",
        "item": "Sports Equipment",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "135",
        "item": "Spreader",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "214",
        "item": "Standing Mirror",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "226",
        "item": "Statue",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "449",
        "item": "Steam Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "374",
        "item": "Stereo",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "186",
        "item": "Stereo Cabinet Glass Door",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "31",
        "item": "Stereo Component",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "213",
        "item": "Stereo Wall Mounted",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "32",
        "item": "Stereo, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "108",
        "item": "Stool",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "397",
        "item": "Storage Bin",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "455",
        "item": "Stove",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "317",
        "item": "Stud, Couch or Hideabed",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "171",
        "item": "Suitcase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "224",
        "item": "Surround Sound Unit",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "473",
        "item": "Swing",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "109",
        "item": "Table",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "437",
        "item": "Table Dining",
        "cubes": "45",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "513",
        "item": "Table Leaf",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "246",
        "item": "Table Saw",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "83",
        "item": "Table, Childs",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "34",
        "item": "Table, Coffee",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "392",
        "item": "Table, Console",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "305",
        "item": "Table, Dining",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "381",
        "item": "Table, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "484",
        "item": "Table, folding",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "137",
        "item": "Table, Large",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "486",
        "item": "Table, night",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "395",
        "item": "Table, patio",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "136",
        "item": "Table, Small",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "172",
        "item": "Table, Utility",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "33",
        "item": "Tables, Drop/Occas",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "35",
        "item": "Tables, End",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "173",
        "item": "Tackle Box",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "266",
        "item": "Tall Candlestick",
        "cubes": "1",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "49",
        "item": "Tea Cart",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "36",
        "item": "Telephone Stand",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "406",
        "item": "Television",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "312",
        "item": "Television Table Model",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "318",
        "item": "Television, Combination",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "459",
        "item": "Tent",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "174",
        "item": "Tire",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "175",
        "item": "Tire w/Rim",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "220",
        "item": "TIVO",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "412",
        "item": "Toaster Oven",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "334",
        "item": "Tool Box",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "422",
        "item": "Toolbox",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "178",
        "item": "Toolchest, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "177",
        "item": "Toolchest, Medium",
        "cubes": "30",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "176",
        "item": "Toolchest, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "434",
        "item": "Tools",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "285",
        "item": "Tote, Large",
        "cubes": "9",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "286",
        "item": "Tote, Medium",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "294",
        "item": "Toy Kitchen",
        "cubes": "6",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "281",
        "item": "Toy, Large",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "436",
        "item": "Toybox",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "179",
        "item": "Trash Can",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "99",
        "item": "Trash Compactor",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "199",
        "item": "Treadmill",
        "cubes": "35",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "144",
        "item": "Tricycle",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "42",
        "item": "Trunk",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "299",
        "item": "TV Tray Set ",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "37",
        "item": "TV, Bigscreen",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "39",
        "item": "TV, Console",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "40",
        "item": "TV, Flatscreen",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "38",
        "item": "TV, Portable",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "41",
        "item": "TV, Stand",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "273",
        "item": "TV-Plasma 50 inch",
        "cubes": "15",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "138",
        "item": "Umbrella",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "110",
        "item": "Utility Cabinet",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "100",
        "item": "Vacuum Cleaner",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "310",
        "item": "Vanity Dresser",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "390",
        "item": "Vase",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "322",
        "item": "Vegetable Bin",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "185",
        "item": "Video Game System",
        "cubes": "3",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "180",
        "item": "Wagon, Child's",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "476",
        "item": "Wall Unit",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "74",
        "item": "Wardrobe, Large",
        "cubes": "40",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "73",
        "item": "Wardrobe, Small",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "101",
        "item": "Washing Machine",
        "cubes": "25",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "181",
        "item": "Wastepaper Basket",
        "cubes": "2",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "207",
        "item": "Water Cooler",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "75",
        "item": "Waterbed",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "443",
        "item": "Wed eater",
        "cubes": "5",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "277",
        "item": "Weight Set",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "139",
        "item": "Wheelbarrow",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "480",
        "item": "Wicker chair",
        "cubes": "8",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "188",
        "item": "Window",
        "cubes": "10",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "416",
        "item": "Wine Rack",
        "cubes": "7",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "195",
        "item": "Wine Refrigerator",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "301",
        "item": "Wood Crate ",
        "cubes": "12",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "182",
        "item": "Work Bench",
        "cubes": "20",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "242",
        "item": "Work Out Machine",
        "cubes": "50",
        "defaultItem": "0",
        "room": "Bed Room2"
      },
      {
        "itemId": "402",
        "item": "Yard Tools",
        "cubes": "4",
        "defaultItem": "0",
        "room": "Bed Room2"
      }
    ]
  }
]);

let roomMapObj: any = {
  Office: "Office",
  "Living-Room": "Living Room",
  "Outdoor-Space": "Porch And Outdoor",
  Entryway: "Entry way",
  "Other-Room": "Other Type",
  "Master-Bedroom": "Master Bedroom",
  "Dining-Room": "Dining Room",
  Garage: "Garage",
  "Bedroom-1": "Bed Room1",
  Kitchen: "Kitchen",
  "Bedroom-2": "Bed Room2",
};

export { cubesheetData, roomMapObj };
